import { put } from 'redux-saga/effects';
import { v4 as uuid } from "uuid";
import { replaceAddressWithHashSaga } from '../address';
import { addOrUpdateShippingGroup } from './shippingModule';

export function* createShippingGroup(obj) {
    const lineItem = yield replaceAddressWithHashSaga(obj);
    const shippingGroup = {
        id: uuid(),
        toAddressHash: lineItem.addressHash,
        shippingMethodToken: '',
        shippingMethod: {
            shippingAmount: 0.0,
            shippingMethodDisplayName: ''
        }
    };
    delete lineItem.addressHash;
    yield put(addOrUpdateShippingGroup(shippingGroup));
    lineItem.shippingGroupId = shippingGroup.id;
    return lineItem;
}
